import CreditCard from './components/CreditCard'

import {GlobalStyle} from './styledComponents'

const App = () => (
  <>
    <GlobalStyle />
    <CreditCard />
  </>
)

export default App
